export default __webpack_public_path__ + "static/media/Icons_5.9f065474.svg";